module.exports = __webpack_public_path__ + "static/media/noiseHeart.095436a1.mp4";